"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckGroupTag = void 0;
var react_1 = __importDefault(require("react"));
var CheckGroup_1 = require("../CheckGroup");
var CheckGroupTag = function (_a) {
    var style = _a.style, props = __rest(_a, ["style"]);
    return (react_1.default.createElement(CheckGroup_1.CheckGroup, __assign({}, props, { rowProps: { gutter: [12, 16] }, renderItem: function (_a) {
            var node = _a.node, rest = _a.rest, isChecked = _a.isChecked, activeColor = _a.activeColor;
            return (react_1.default.createElement("div", __assign({}, rest, { style: __assign(__assign({ padding: "0.5rem 1rem" }, rest.style), { cursor: "pointer", border: "1px solid " + (isChecked ? activeColor : "#D9D9D9"), borderRadius: "3px" }) }), node));
        } })));
};
exports.CheckGroupTag = CheckGroupTag;
